import { render, staticRenderFns } from "./userDashboardCustomerCare.vue?vue&type=template&id=64f9306d&scoped=true"
import script from "./userDashboardCustomerCare.vue?vue&type=script&lang=js"
export * from "./userDashboardCustomerCare.vue?vue&type=script&lang=js"
import style0 from "./userDashboardCustomerCare.vue?vue&type=style&index=0&id=64f9306d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f9306d",
  null
  
)

export default component.exports